import { createEntityCollectionStore, getEntityCollectionActions, Scope } from '@recruitee/ngrx';
import type { ReferralsTerm } from '@recruitee/referrals-types';

const { actions, selectors, reducer, namespace } = createEntityCollectionStore<ReferralsTerm>()(
  'ReferralsTermsCollection',
  {
    customActions: adapter => {
      const actions = getEntityCollectionActions(adapter, ({ id }) => id!);
      return {
        updateAll: (state, payload: { terms: ReferralsTerm[]; scope?: Scope }) =>
          adapter.markAsPending(state, { scope: payload.scope || null, entities: [] }),
        updateAllSuccess: actions.fetchCollectionSuccess,
        updateAllFailed: actions.fetchCollectionFailed,
      };
    },
  },
);

export {
  actions as ReferralsTermsCollectionActions,
  selectors as ReferralsTermsCollectionSelectors,
  reducer as ReferralsTermsCollectionReducer,
  namespace as ReferralsTermsCollectionNamespace,
};
